<div class="cover" #cover (click)="onCoverClick($event)"></div>
<ng-template #popoversContainer></ng-template>